export default __webpack_public_path__ + "static/media/signup06tour-slide1.5e6a9495.jpg";